import React from 'react';

import {GradientAnimation} from './styles';

const LoadingGradientAnimation = () => <GradientAnimation />;

export default LoadingGradientAnimation;
